/**
 * Module « catalogue » — CAT-01 à CAT-04.
 *
 * Saisons (avec leur phase), spectacles et représentations, et l’annulation
 * d’une représentation avec ses conséquences chiffrées (ARCHITECTURE §9.4).
 *
 * ★ Depuis le retour client du 22 août, un troisième écran : la FICHE d'un
 * spectacle. Le programme d'une saison ne déroule plus toutes les dates de tous
 * les spectacles ; il en montre les premières et renvoie ici. Le raisonnement
 * complet est en tête de `PageSpectacleDetail.tsx`.
 */

import { lazy } from 'react'
import type { RouteObject } from 'react-router'

import { SEGMENT_SPECTACLE } from './chemins'

const PageSaisons = lazy(() => import('./PageSaisons').then((m) => ({ default: m.PageSaisons })))
const PageSaisonDetail = lazy(() =>
  import('./PageSaisonDetail').then((m) => ({ default: m.PageSaisonDetail })),
)
const PageSpectacleDetail = lazy(() =>
  import('./PageSpectacleDetail').then((m) => ({ default: m.PageSpectacleDetail })),
)
const PageIncident = lazy(() => import('./PageIncident').then((m) => ({ default: m.PageIncident })))
const PageListeIncidents = lazy(() =>
  import('./PageIncident').then((m) => ({ default: m.PageListeIncidents })),
)
const PagePolitiqueIncident = lazy(() =>
  import('./PageIncident').then((m) => ({ default: m.PagePolitiqueIncident })),
)

export const routesCatalogue: RouteObject[] = [
  { index: true, element: <PageSaisons /> },
  { path: 'politique-incidents', element: <PagePolitiqueIncident /> },
  /* ★ La fiche AVANT le détail de saison : `:saisonId` seul ne capte pas
     `:saisonId/spectacles/:spectacleId`, mais l'ordre suit ici celui de la
     lecture — du plus précis au plus général. */
  { path: SEGMENT_SPECTACLE, element: <PageSpectacleDetail /> },
  { path: ':saisonId', element: <PageSaisonDetail /> },
]

export const routesIncidents: RouteObject[] = [
  { index: true, element: <PageListeIncidents /> },
  { path: ':representationId', element: <PageIncident /> },
]
